import { Component, OnInit, Input, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl, FormsModule } from '@angular/forms';

@Component({
  selector: 'app-selector-tvehiculo',
  templateUrl: './selector-tvehiculo.component.html',
  styleUrls: ['./selector-tvehiculo.component.css']
})


export class SelectorTvehiculoComponent implements OnInit {

  @Input() valorDefecto: string;
  
  constructor() { }

  ngOnInit(): void {
  }

  

}
